import React from "react";
import DashboardWrapper from "components/lib/Global/DashboardWrapper";
import Hero from "components/lib/Global/Hero";
import OrgComplianceDashboard from "components/Compliance/OrgComplianceDashboard";
import ComplianceAccessGate from "components/Compliance/ComplianceAccessGate";

const OrgComplianceDashboardPage = () => (
  <DashboardWrapper>
    <ComplianceAccessGate allowAdminBypass>
      <div className="space-y-8 py-10">
        <Hero
          heading="OrgAdmin Compliance Summary"
          description="Aggregated compliance insights across assigned corporates."
        />
        <OrgComplianceDashboard />
      </div>
    </ComplianceAccessGate>
  </DashboardWrapper>
);

export default OrgComplianceDashboardPage;
